(() => {
  if (window.tabGenderPillsLoaded) return;
  window.tabGenderPillsLoaded = true;
  function current() { const value = new URL(location.href).searchParams.get('gender'); return ['girls', 'boys'].includes(value) ? value : 'all'; }
  function apply() {
    const nav = document.querySelector('[data-tab-gender-pills]');
    const grid = document.querySelector('#product-grid');
    if (!nav || !grid) return;
    const gender = current(); let total = 0, visible = 0;
    for (const card of grid.children) {
      const titleLink = card.querySelector('.product-card-title');
      if (!titleLink) continue;
      const title = (titleLink.textContent || titleLink.title || '').toLowerCase();
      const unisex = /unisex|compression|e2300/.test(title);
      const match = gender === 'all' || unisex || (gender === 'girls' ? /\bgirls?\b/.test(title) : /\bboys?\b/.test(title));
      card.toggleAttribute('data-tab-gender-hidden', !match);
      total++; if (match) visible++;
    }
    nav.hidden = false;
    for (const link of nav.querySelectorAll('[data-gender]')) {
      const selected = link.dataset.gender;
      link.setAttribute('aria-current', String(gender === selected));
      const url = new URL(location.href);
      url.searchParams.delete('page');
      if (selected === 'all') url.searchParams.delete('gender'); else url.searchParams.set('gender', selected);
      link.href = url.pathname + url.search + url.hash;
    }
    const count = nav.querySelector('[data-gender-count]');
    const text = visible + (visible === 1 ? ' style' : ' styles') + (gender === 'all' ? '' : ' for ' + gender);
    if (count.textContent !== text) count.textContent = text;
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-tab-gender-pills] [data-gender]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault(); history.pushState({}, '', link.href); apply();
  });
  window.addEventListener('popstate', apply);
  function init() {
    apply();
    const main = document.querySelector('main') || document.body;
    new MutationObserver(records => {
      if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('#product-grid, .column, [data-tab-gender-pills]') || n.querySelector?.('#product-grid'))))) apply();
    }).observe(main, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
